import ReactGA from "react-ga4";
import { REQUEST_TIMEOUT } from "src/shared/config";
import ApiUtils from "../apiUtils";
import { IRequestData, IMiddleware } from "../types";

class GAMiddleware implements IMiddleware {
  startTime = 0;
  responseTime = 0;
  requestEndTime = 0;

  getRequestData(): void {
    this.startTime = performance.now();
  }

  getResponseData(request: IRequestData, response: Response): void {
    this.responseTime = performance.now() - this.startTime;
    this.requestEndTime = Date.now();
    if (response.headers && !response.headers.get("X-Browser-Cache")) {
      // react-ga don't have latest type definition causing dimensionX as unwanted arg
      (ReactGA as any).event({
        category: "API Call Time (ms)",
        action: `API Call${this.responseTime > REQUEST_TIMEOUT ? " (Invalid?)" : ""}`,
        label: `${ApiUtils.buildUrlWithParams(request.url as string, request.params)} : success`,
        value: Math.round(this.responseTime), // Should be integer else GA won't accept
        dimension2: String(this.requestEndTime),
      });
    }
  }

  getErrorData(request: IRequestData, error: Response | TypeError): void {
    this.responseTime = performance.now() - this.startTime;
    this.requestEndTime = Date.now();
    if (error instanceof TypeError) {
      console.error(error);
      return;
    }
    const statusCode = error?.status || 0;
    if (!statusCode) console.error(error);
    // react-ga don't have latest type definition causing dimensionX as unwanted arg
    (ReactGA as any).event({
      category: "API Error",
      action: String(statusCode),
      label: `${ApiUtils.buildUrlWithParams(request.url as string, request.params)} : failed`,
      value: Math.round(this.responseTime), // Should be integer else GA won't accept
      dimension2: String(this.requestEndTime),
    });
  }
}

export default GAMiddleware;
